import {
    fetchPostBlob,
    fetchPost,
    fetchGet
} from './index'

export default {
    /**
     * 登录
     */
    login(params) {
        return fetchPost('/login', params)
    },
    /**
     * 分页用户列表
     */
    getPagedPersonAuthList(params) {
        return fetchGet('/personAuthenticateInfo/getPagedPersonAuthList', params)
    },
    /**
     * 无分页全部用户
     */
    getUserList(params) {
        return fetchGet('/authUser/getUserList', params)
    },
    /**
     * 权限用户模块---分页用户列表
     */
    getPagedUserList(params) {
        return fetchGet('/authUser/getPagedUserList', params)
    },
    /**
     * 获取所有角色
     */
    getAuthRoleList(params) {
        return fetchGet('/authRole/getAuthRoleList', params)
    },
    /**
     * 修改权限树接口
     */
    saveAuth(params) {
        return fetchPost('/authRoleFunc/saveAuth', params)
    },
    /**
     * 新增用户接口
     */
    addUser(params) {
        return fetchPost('/authUser/addUser', params)
    },
    /**
     * 编辑用户接口
     */
    updateUser(params) {
        return fetchPost('/authUser/updateUser', params)
    },
    /**
     * 用户接口修改密码
     */
    password(params) {
        return fetchPost('/authUser/admin/password', params)
    },
    /**
     * 新增角色
     */
    addRole(params) {
        return fetchPost('/authRole/addRole', params)
    },
    /**
     * 删除角色
     */
    deleteRole(params) {
        return fetchGet('/authRole/deleteRole', params)
    },
    /**
     * 修改角色
     */
    updateRole(params) {
        return fetchPost('/authRole/updateRole', params)
    },
    /**
     * 获取所有菜单--->权限设置
     */
    getAuthFuncList(params) {
        return fetchGet('/authRole/getAuthFuncList', params)
    },
    /**
     * 指派管理员--->权限设置
     */
    addAdmin(params) {
        return fetchPost('/authRole/sysadmin/addAdmin', params)
    },
    // 个人认证
    personList(params) { //个人认证-分页列表
        return fetchGet('/personAuthenticateInfo/getPagedPersonAuthList', params)
    },
    personDetils(params) { //个人认证-详情
        return fetchGet('/personAuthenticateInfo/getPersonAuthenticateInfoById', params)
    },
    personadopt(params) { //个人认证-通过按钮
        return fetchGet('/personAuthenticateInfo/pass', params)
    },
    personNopt(params) { //个人认证-审核不通过按钮
        return fetchGet('/personAuthenticateInfo/fail', params)
    },
    // 企业认证
    entList(params) { //企业认证-分页列表
        return fetchGet('/businessAuthenticateInfo/getPagedBusinessAuthList', params)
    },
    entDetils(params) { //企业认证-详情页
        return fetchGet('/businessAuthenticateInfo/getBusinessAuthenticateInfoById', params)
    },
    entDetiladopt(params) { //企业认证-通过按钮
        return fetchGet('/businessAuthenticateInfo/pass', params)
    },
    entDetilNopt(params) { //企业认证-不通过按钮
        return fetchGet('/businessAuthenticateInfo/fail', params)
    },
    // 用户管理
    userIndex(params) { // 商户首页
        return fetchGet('/home/getHomeData', params)
    },
    userDetils(params) { // 商户详情
        return fetchGet('/basicInfo/getBasicInfoById', params)
    },
    userList(params) { //个人认证-不通过按钮
        return fetchGet('/basicInfo/getPagedBasicInfoList', params)
    },
    getpPagedSysActionLogList(params) { //  操作日志查询接口
        return fetchGet('/sysActionLog/getpPagedSysActionLogList', params)
    },
    getProductCatalogList(params) { //  商品分类列表分页查询接口
        return fetchGet('/productCatalog/getProductCatalogList?times=' + new Date().getTime(), params)
    },
    addProductCatalog(params) { //  新增分类接口
        return fetchPost('/productCatalog/addProductCatalog', params)
    },
    updateProductCatalog(params) { //  修改分类接口
        return fetchPost('/productCatalog/updateProductCatalog', params)
    },
    deleteProductCatalog(params) { //  删除分类接口
        return fetchPost('/productCatalog/deleteProductCatalog', params)
    },
    moveDown(params) { //  下降
        return fetchGet('/productCatalog/moveDown', params)
    },
    moveUp(params) { // 上升
        return fetchGet('/productCatalog/moveUp', params)
    },
    getProducSpecNameList1(params) { // 服务需求类型
        return fetchGet('/serviceConsult/getProducSpecNameList', params)
    },
    getPagedProductList1(params) { // 需求分页列表
        return fetchGet('/serviceConsult/getPagedProductList', params)
    },
    getServiceConsultById(params) { // 需求获取详情
        return fetchGet('/serviceConsult/getServiceConsultById', params)
    },
    confirm(params) { // 订单管理 -- 同意、拒绝退款/开通
        return fetchGet('/order/confirm', params)
    },
    getOrderById(params) { // 订单管理 -- GET  获订单详情
        return fetchGet('/order/getOrderById', params)
    },
    getPagedPOrderList(params) { // 订单管理 --  订单列表
        return fetchGet('/order/getPagedPOrderList', params)
    },
    addProductSupp(params) { // 添加供应商
        return fetchPost('/productSupp/addProductSupp', params)
    },
    selProductSuppById(params) { //回显
        return fetchGet('/productSupp/selProductSuppById', params)
    },
    deleteProductSupp(params) { // 删除供应商
        return fetchGet('/productSupp/deleteProductSupp', params)
    },
    getPagedProductSuppList(params) { // 供应商分页列表
        return fetchGet('/productSupp/getPagedProductSuppList', params)
    },
    updateProductSupp(params) { // 编辑供应商
        return fetchPost('/productSupp/updateProductSupp', params)
    },
    updateRemark(params) { // 修改卖家备注
        return fetchGet('/order/updateRemark', params)
    },
    openService(params) { // 确认开通订单
        return fetchPost('/order/openService', params)
    },
    getOrderById(params) { // 获取订单详情
        return fetchGet('/order/getOrderById', params)
    },
    confirm(params) { // 订单申请退款接口
        return fetchGet('/order/confirm', params)
    },
    /**
     * 分页角色列表
     */
    getpPagedAuthRoleList1(params) {
        return fetchGet('/authRole/getpPagedAuthRoleList', params)
    },
    /**
     * 获取某个角色已有菜单--->权限设置
     */
    getAuthRoleFuncList(params) {
        return fetchGet('/authRole/getAuthRoleFuncList', params)
    },
    // 用户管理
    userIndex(params) { // 商户首页
        return fetchGet('/home/getHomeData', params)
    },
    userDetils(params) { // 商户详情
        return fetchGet('/basicInfo/getBasicInfoById', params)
    },
    userList(params) { //个人认证-不通过按钮
        return fetchGet('/basicInfo/getPagedBasicInfoList', params)
    },
    getpPagedAuthRoleList(params) { //  登陆日志查询接口
        return fetchGet('/sysAccessLog/getpPagedAuthRoleList', params)
    },
    moveDown(params) { //  下降
        return fetchGet('/productCatalog/moveDown', params)
    },
    moveUp(params) { // 上升
        return fetchGet('/productCatalog/moveUp', params)
    },
    getProducSpecNameList(params) { // 规格名称
        return fetchGet('/productSpecName/getProducSpecNameList', params)
    },
    addProduct(params) { // 商品发布
        return fetchPost('/product/addProduct', params)
    },
    getProducById(params) { // 按商品id获取商品
        return fetchGet('/product/getProducById', params)
    },
    updateProduct(params) { // 商品编辑
        return fetchPost('/product/updateProduct', params)
    },
    getPagedProductList(params) { //商品管理分页列表
        return fetchGet('/product/getPagedProductList', params)
    },
    updateRecommendState(params) { //商品推荐
        return fetchPost('/product/updateRecommendState', params)
    },
    batchShelves(params) { //上下架
        return fetchPost('/product/batchShelves', params)
    },
    updateSaleNum(params) { //修改销量
        return fetchPost('/product/updateSaleNum', params)
    },
    deleteProduct(params) { //商品-删除
        return fetchPost('/product/deleteProduct', params)
    },
    indexInfo(params) { //首页信息
        return fetchGet('/home/getLightCloudHomeData', params)
    },
    //供应商无分页列表
    getProductSuppList(params) {
        return fetchGet('/productSupp/getProductSuppList', params)
    },
    //平台商无分页列表
    getProductPlatList(params) {
        return fetchGet('/platform/getPlatformProvideList', params)
    },
    //------------------商户子系统管理模块

    getPagedPlatformList(params) { //子系统分页列表
        return fetchGet('/platform/getPagedPlatformList', params)
    },
    getPlatformByPlatId(params) { //子系统详情
        return fetchGet('/platform/getPlatformByPlatId', params)
    },
    addPlatform(params) { //添加子系统
        return fetchPost('/platform/addPlatform', params)
    },

    updatePlatform(params) { //修改子系统
        return fetchPost('/platform/updatePlatform', params)
    },
    addProductSupp(params) { //添加供应商
        return fetchPost('/productSupp/addProductSupp', params)
    },
    updateProductSupp(params) { //添加供应商
        return fetchPost('/productSupp/updateProductSupp', params)
    },
    getTreePlatFuncList(params) { //运营菜单列表
        return fetchGet('/platFunc/getTreePlatFuncList', params)
    },
    getTreeSHPlatFuncList(params) { //商户菜单列表
        return fetchGet('/clientPlatFunc/getTreePlatFuncList', params)
    },
    getTreeClientVersionList(params) { //商户菜单
        return fetchGet('/platVersion/getTreeClientVersionList', params)
    },
    addPlatVersion(params) { //商户添加
        return fetchPost('/platVersion/addPlatVersion', params)
    },
    updatePlatVersion(params) { //商户编辑
        return fetchPost('/platVersion/updatePlatVersion', params)
    },
    deletePlatVersion(params) { //删除商户菜单
        return fetchGet('/platVersion/deletePlatVersion', params)
    },
    addPlatFunc(params) { //运营添加
        return fetchPost('/platFunc/addPlatFunc', params)
    },
    updatePlatFunc(params) { //编辑添加
        return fetchPost('/platFunc/updatePlatFunc', params)
    },
    deletePlatFunc(params) { //删除运营
        return fetchGet('/platFunc/deletePlatFunc', params)
    },
    getPlatAuthByPlatId(params) { //子模块权限菜单
        return fetchPost('/platform/getPlatAuthByPlatId', params)
    },
    getPlatRoleList(params) {
        return fetchGet('/platRole/getPlatRoleList', params)
    },
    getPagedPlatRoleList(params) { //子模块权限角色管理列表
        return fetchGet('/platRole/getPagedPlatRoleList', params)
    },
    deletePlatRole(params) { //子模块权限角色删除
        return fetchGet('/platRole/deletePlatRole', params)
    },
    addPlatRole(params) { //子模块权限角色 新增
        return fetchPost('/platRole/addPlatRole', params)
    },
    updatePlatRole(params) { //子模块权限角色 编辑
        return fetchPost('/platRole/updatePlatRole', params)
    },
    sysadminAddAdmin(params) { //指定管理员
        return fetchPost('/platRole/sysadmin/addAdmin', params)
    },
    getAuthFuncList2(params) { //子系统获取所有权限
        return fetchGet('/platRole/getAuthFuncList', params)
    },
    getAuthRoleFuncList2(params) { //子系统菜单回显
        return fetchGet('/platRole/getAuthRoleFuncList', params)
    },
    saveAuth2(params) { //保存子菜单模块权限
        return fetchPost('/platRole/saveAuth', params)
    },
    /**
     * 获取所有平台的版本
     */
    getBusVersion(params) {
        return fetchGet('/basicInfo/getBusVersion', params)
    },
    /**
     * 获取某个商户已有的版本
     */
    getBusVersionById(params) {
        return fetchGet('/basicInfo/getBusVersionById', params)
    },
    /**
     * 更改商户平台版本
     */
    updateBusVersionById(params) {
        return fetchPost('/basicInfo/updateBusVersionById', params)
    },
    /**
     * 用户中心——子账户管理
     */
    selectAuthUserList(params) {
        return fetchPost('/bpAuthUser/selectAuthUserList', params)
    },
    /**
     * 用户中心——子账户权限查询
     */
    selectUserPlatVersion(params) {
        return fetchPost('/bpAuthUser/selectUserPlatVersion', params)
    },
    //查看平台版本
    getPlatVersionByPlatId(params) {
        return fetchPost('/platVersion/getPlatVersionByPlatId', params)
    },
    //获取平台版本权限
    getAuthPlatFuncList(params) {
        return fetchGet('/platVersion/getAuthFuncList', params)
    },
    //获取某个平台版本权限 回显
    getAuthRolePlatFuncList(params) {
        return fetchGet('/platVersion/getAuthRoleFuncList', params)
    },
    //修改平台版本权限
    savePlatAuth(params) {
        return fetchPost('/platVersion/saveAuth', params)
    },
    //版本管理 业务范围查询
    getPagedPlatVersionScopeList(params) {
        return fetchGet('/platVersionScope/getPagedPlatVersionScopeList', params)
    },
    //版本管理 业务范围添加
    addPlatVersionScope(params) {
        return fetchPost('/platVersionScope/addPlatVersionScope', params)
    },
    //版本管理 业务范围修改
    updatePlatVersionScope(params) {
        return fetchPost('/platVersionScope/updatePlatVersionScope', params)
    },
    //版本管理 业务范围删除
    deletePlatVersionScope(params) {
        return fetchGet('/platVersionScope/deletePlatVersionScope', params)
    },
    //信息管理
    selectInformationPageList(params) {
        return fetchPost('/information/selectInformationPageList', params)
    },
    // 子平台角色接口
    getUserRoleById(params) {
        return fetchGet('/authUser/getUserRoleById', params)
    },
    //查看用户
    getRoleUserById(params) {
        return fetchGet('/authRole/getRoleUserById', params)
    },
    // 删除用户
    deleteUser(params) {
        return fetchGet('/authUser/deleteUser', params)
    },
    //查看口令
    viewPassword(params){
        return fetchPost('/google/auth/get',params)
    },
    //刷新口令
    refreshPassword(params){
        return fetchPost('/google/auth/refresh',params)
    },
    //禁用用户
    disableUser(params){
        return fetchGet('/operplatApi/authUser/deactivate',params)
    },
    //banner管理-接口
    getPagedBannerList(params) { //banner管理-查询
        return fetchGet('/banner/getPagedBannerList', params)
    },
    updateBannerState(params) { //banner管理-开启关闭
        return fetchPost('/banner/updateBannerState', params)
    },
    deleteBanner(params) { //banner管理-删除
        return fetchGet('/banner/deleteBanner', params)
    },
    addBanner(params) { //新增banner
        return fetchPost('/banner/addBanner', params)
    },
    updateBanner(params) { //编辑banner
        return fetchPost('/banner/updateBanner', params)
    },
    getBannerById(params) { //回显接口
        return fetchGet('/banner/getBannerById', params)
    },
    // 公告管理-接口
    getPagedNoticeList(params) { //列表
        return fetchGet('/notice/getPagedNoticeList', params)
    },
    deleteNotice(params) { //删除
        return fetchGet('/notice/deleteNotice', params)
    },
    updateNoticeRecommend(params) { //推荐
        return fetchPost('/notice/updateNoticeRecommend', params)
    },
    addNotice(params) { //新增公告
        return fetchPost('/notice/addNotice', params)
    },
    getNoticeById(params) { //回显
        return fetchGet('/notice/getNoticeById', params)
    },
    updateNotice(params) { //编辑
        return fetchPost('/notice/updateNotice', params)
    },
    getLocationById(params) { //推荐商品位置下拉的
        return fetchGet('/productLocationName/getLocationById', params)
    },
    getRecommendInfo(params) { //推荐回显
        return fetchGet('/product/getRecommendInfo', params)
    },
    deleteProductRecommendInfo(params) { //删除
        return fetchPost('/product/deleteProductRecommendInfo', params)
    },
    getPagedCouponList(params) { //优惠券管理列表
        return fetchGet('/coupon/getPagedCouponList', params)
    },
    updateCouponState(params) { //开启关闭
        return fetchPost('/coupon/updateCouponState', params)
    },
    getPlatList(params) { //全部
        return fetchGet('/coupon/getPlatList', params)
    },
    addCoupon(params) { //新增优惠券
        return fetchPost('/coupon/addCoupon', params)
    },
    updateCoupon(params) { //编辑优惠券
        return fetchPost('/coupon/updateCoupon', params)
    },
    getCouponById(params) { //优惠券回显
        return fetchGet('/coupon/getCouponById', params)
    },
    deleteCoupon(params) { //删除
        return fetchGet('/coupon/deleteCoupon', params)
    },
    saveCouponRule(params) { //优惠券规则
        return fetchPost('/coupon/saveCouponRule', params)
    },
    getCouponRule(params) { //拉取优惠券规则
        return fetchGet('/coupon/getCouponRule', params)
    },
    getPagedCouponUseList(params) { //领取列表
        return fetchGet('/coupon/getPagedCouponUseList', params)
    },
    getPagedCouponReceiveList(params) { //发放列表
        return fetchGet('/coupon/getPagedCouponReceiveList', params)
    },
    getCouponByClientIdList(params) { //优惠券tab
        return fetchGet('/coupon/getCouponByClientIdList', params)
    },
    bannerJson(params) {
        return fetchGet('/banner/bannerJson', params)
    },
    createCataJson(params) { //生成
        return fetchGet('/productCatalog/createCataJson', params)
    },
    getUpdateOrderFee(params) { //订单修改
        return fetchGet('/order/getUpdateOrderFee', params)
    },
    getPlatformList(params) { //获取数据权限接口 没参数
        return fetchGet('/platform/getPlatformList', params)
    },
    addPlatRoleData(params) { //提交数据权限接口  { "roleId":'',"platIds":''}
        return fetchPost('/platRolePlat/addPlatRoleData', params)
    },
    getPlatRoleDataByPlatId(params) { //数据权限回显 参数roleId
        return fetchGet('/platRolePlat/getPlatRoleDataByPlatId', params)
    },
    //运营平台线下充值查询接口：/fincPayOffline/selectFincPayOfflinePageList POST请求 参数：payAccountName：汇款名称、startTime：开始时间、endTime：结束时间
    selectFincPayOfflinePageList(params) {
        return fetchPost('/fincPayOffline/selectFincPayOfflinePageList', params)
    },
    //运营平台线下充值确认接口：/fincPayOffline/updateFincPayOffline POST请求 参数：logId：返回数据ID、confirmBy：运营平台登陆人ID
    updateFincPayOffline(params) {
        return fetchPost('/fincPayOffline/updateFincPayOffline', params)
    },
    //selectFincPayOfflineCount  POST请求  count-全部 confirmCount-待确定 echargeCount充值成功
    selectFincPayOfflineCount(params) {
        return fetchPost('/fincPayOffline/selectFincPayOfflineCount', params)
    },
    /**
     *
     * @param {代理商体系}}}
     */
    selectAgentInfoPageList(params) { //列表
        return fetchPost('/agentInfo/selectAgentInfoPageList', params)
    },
    addAgentAgreement(params) { //确认协议和上传协议
        return fetchPost('/agentInfo/addAgentAgreement', params)
    },
    updateAgentInfo(params) { //确认缴纳保证金
        return fetchPost('/agentInfo/updateAgentInfo', params)
    },
    sms(params) { // 通知代理商接口
        return fetchPost('/agentInfo/sms', params)
    },
    exportAgentInfoList(params) { //导出接口
        return fetchPost('/agentInfo/exportAgentInfoList', params)
    },
    selectAgentInfoDetails(params) { //代理商详情
        return fetchPost('/agentInfo/selectAgentInfoDetails', params)
    },
    addAgentTrack(params) { //跟踪客服提交
        return fetchPost('/agentInfo/addAgentTrack', params)
    },
    addAgentDis(params) { //支付佣金接口
        return fetchPost('/agentInfo/addAgentDis', params)
    },
    selectAgentClientPageList(params) { //客户列表
        return fetchPost('/agentInfo/selectAgentClientPageList', params)
    },
    selectAgentClientDetails(params) { //客户详情
        return fetchPost('/agentInfo/selectAgentClientDetails', params)
    },
    selectAgentOrderPageList(params) { //订单列表接口
        return fetchPost('/agentInfo/selectAgentOrderPageList', params)
    },
    exportAgentOrderPageList(params) { //订单列表导出
        return fetchPost('/agentInfo/exportAgentOrderPageList', params)
    },
    selectAgentOrderDetails(params) { //订单详情
        return fetchPost('/agentInfo/selectAgentOrderDetails', params)
    },
    selectAgentDisPageList(params) { //佣金列表接口
        return fetchPost('/agentInfo/selectAgentDisPageList', params)
    },
    selectAgentDisListSum(params) { //佣金统计接口
        return fetchPost('/agentInfo/selectAgentDisListSum', params)
    },
    selectAgentInfolink(params) { //代理商推广链接接口
        return fetchPost('/agentInfo/selectAgentInfolink', params)
    },
    selectAgentDisDetail(params) { //月度佣金
        return fetchPost('/agentInfo/selectAgentDisDetail', params)
    },
    selectAgentDisQuarter(params) { //季度佣金
        return fetchPost('/agentInfo/selectAgentDisQuarter', params)
    },
    selectAgentBond(params) { //佣金详情
        return fetchPost('/agentInfo/selectAgentBond', params)
    },
    addOrder(params) { //订单录入接口
        return fetchPost('/agentInfo/addOrder', params)
    },
    updateOrderLogAgain(params) { //再次支付
        return fetchPost('/agentInfo/updateOrderLogAgain', params)
    },
    exportAgentDisPageList(params) { //佣金列表导出接口
        return fetchPost('/agentInfo/exportAgentDisPageList', params)
    },
    selectAgentDisQuarterSum(params) { //统计
        return fetchPost('/agentInfo/selectAgentDisQuarterSum', params)
    },
    selectAgentOrderListSum(params) { //统计
        return fetchPost('/agentInfo/selectAgentOrderListSum', params)
    },
    addFriendship(params) { //新增
        return fetchPost('/friendship/addFriendship', params)
    },
    getPageFriendshipList(params) { //分页列表
        return fetchGet('/friendship/getPageFriendshipList', params)
    },
    updateFriendshipById(params) { //修改
        return fetchPost('/friendship/updateFriendshipById', params)
    },
    delFriendshipById(params) { //删除
        return fetchGet('/friendship/delFriendshipById', params)
    },
    /**
     *
     * @param {活动体系}}}
     */
    addActivityRecommend(params) { //活动推荐新增
        return fetchPost('/activityRecommend/addActivityRecommend', params)
    },
    getPageActivityRecommendList(params) { //活动列表
        return fetchGet('/activityRecommend/getPageActivityRecommendList', params)
    },
    updateActivityRecommend(params) { //编辑
        return fetchPost('/activityRecommend/updateActivityRecommend', params)
    },
    delActivityRecommendById(params) { //删除
        return fetchGet('/activityRecommend/delActivityRecommendById', params)
    },
    addActivityAdmin(params) { //活动管理新增
        return fetchPost('/activityAdmin/addActivityAdmin', params)
    },
    getPageActivityAdminList(params) { //分页活动管理列表
        return fetchGet('/activityAdmin/getPageActivityAdminList', params)
    },
    updateActivityAdmin(params) { //修改
        return fetchPost('/activityAdmin/updateActivityAdmin', params)
    },
    selActivityAdminById(params) { //回显
        return fetchGet('/activityAdmin/selActivityAdminById', params)
    },
    updateActivityAdminRecommend(params) { //推荐
        return fetchPost('/activityAdmin/updateActivityAdminRecommend', params)
    },
    delActivityAdminById(params) { //删除
        return fetchGet('/activityAdmin/delActivityAdminById', params)
    },

    getNewsPageList(params) { //新闻列表
        return fetchGet('/news/getNewsPageList', params)
    },


    newsgetProductCatalogList(params) { //  商品分类列表分页查询接口
        return fetchGet('/newsCatalog/getProductCatalogList?times=' + new Date().getTime(), params)
    },
    newsaddProductCatalog(params) { //  新增分类接口
        return fetchPost('/newsCatalog/addProductCatalog', params)
    },
    newsupdateProductCatalog(params) { //  修改分类接口
        return fetchPost('/newsCatalog/updateProductCatalog', params)
    },
    newsdeleteProductCatalog(params) { //  删除分类接口
        return fetchPost('/newsCatalog/deleteProductCatalog', params)
    },
    newsmoveDown(params) { //  下降
        return fetchGet('/newsCatalog/moveDown', params)
    },
    newsmoveUp(params) { // 上升
        return fetchGet('/newsCatalog/moveUp', params)
    },


    addNews(params) {
        return fetchPost('/news/addNews', params)
    },
    delNews(params) {
        return fetchGet('/news/delNewsById', params)
    },
    selNewsById(params) {
        return fetchGet('/news/selNewsById', params)
    },
    updateNews(params) {
        return fetchPost('/news/updateNews', params)
    },


    //疫情接口 /statisticsData/selStatisticsDataPageList   Get  pageIndex（当前页） pageSize（每页条数）
    selStatisticsDataPageList(params) {
        return fetchGet('/statisticsData/selStatisticsDataPageList', params)
    },
    //新增疫情  /statisticsData/updateStatisticsData
    updateStatisticsData(params) {
        return fetchPost('/statisticsData/updateStatisticsData', params)
    },

    // 模板接口 GET /tempCatalog/getProductCatalogList
    tempCatalogList(params) {
        return fetchGet('/tempCatalog/getProductCatalogList', params)
    },
    //模版列表下移 	GET /tempCatalog/moveDown
    tempCatalogMoveDown(params) {
        return fetchGet('/tempCatalog/moveDown', params)
    },
    //模版列表上移 	GET /tempCatalog/moveUp
    tempCatalogMoveUp(params) {
        return fetchGet('/tempCatalog/moveUp', params)
    },
    //模版新增 POST /tempCatalog/addProductCatalog
    tempCatalogAdd(params) {
        return fetchPost('/tempCatalog/addProductCatalog', params)
    },
    //模版删除 POST /tempCatalog/deleteProductCatalog
    tempCatalogDel(params) {
        return fetchPost('/tempCatalog/deleteProductCatalog', params)
    },
    //获取模板数据 GET /template/selTemplateById
    getTemplateJson(params) {
        return fetchGet('/template/selTemplateById', params)
    },
    selTemplatePageList(params) {
        return fetchGet('/template/selTemplatePageList', params)
    },
    //模板 POST /template/updateTemplate
    updateTemplate(params) {
        return fetchPost('/template/updateTemplate', params)
    },
    //POST /tempCatalog/updateProductCatalog
    pageUpdateProductCatalog(params) {
        return fetchPost('/tempCatalog/updateProductCatalog', params)
    },

    //  服务合作伙伴 -> 获取列表
    getIndustryPartnersUserList(params) {
        return fetchPost('/industryPartners/selIndustryPartnersPageList', params);
    },
    //  服务合作伙伴 -> 上传协议/设置协议编号
    uploadIndustryPartnersAgreement(params) {
        return fetchPost('/industryPartners/addPartnersAgreement', params);
    },
    //  服务合作伙伴 -> 设置保证金金额
    setIndustryPartnersBond(params) {
        return fetchGet('/industryPartners/updateIndustryPartners', params);
    },
    //  服务合作伙伴 -> 列表导出
    downloadUserList(params) {
        return fetchPostBlob('/industryPartners/exportIndustryPartnersPageList', params);
    },
    //  服务合作伙伴 -> 列表详情
    getIndustryPartnersUserDetails(params) {
        return fetchGet('/industryPartners/selIndustryPartners', params);
    },
    //  服务合作伙伴 -> 协议记录查询
    getProtocolRecord(params) {
        return fetchGet('/industryPartners/selPartnersAgreement', params);
    },
    //  服务合作伙伴 -> 保证金详情查询
    getBondInfo(params) {
        return fetchGet('/industryPartners/selPartnersBond', params);
    },
    //  服务合作伙伴 -> 跟踪记录列表
    getTrackingRecord(params) {
        return fetchGet('/industryPartners/selPartnersTrackList', params);
    },
    //  服务合作伙伴 -> 跟踪记录列表 添加
    setTrackingRecord(params) {
        return fetchPost('industryPartners/addPartnersTrack', params);
    },
    //  服务合作伙伴 -> 接单列表
    getIndustryPartnersOrderList(params) {
        return fetchPost('/partnersBusiness/selReceivingSheetPageList', params);
    },
    //  服务合作伙伴 -> 接单列表 -> 详情
    getIndustryPartnersOrderDetails(params) {
        return fetchGet('/partnersBusiness/selPartnersBusiness', params);
    },
    //  服务合作伙伴 -> 接单列表 -> 导出
    downloadOrderList(params) {
        return fetchPostBlob('/partnersBusiness/exportReceivingSheetPageList', params);
    },
    //  服务合作伙伴 -> 接单列表 -> 确认完成
    downloadOrderComplete(params) {
        return fetchGet('/partnersBusiness/updatePartnersBusinessStateSix', params);
    },
    //  服务合作伙伴 -> 商机列表
    getIndustryPartnersBusinessOpportunityList(params) {
        return fetchPost('/partnersBusiness/selPartnersBusinessPageList', params);
    },
    //  服务合作伙伴 -> 商机列表 -> 发布
    setIndustryPartnersBusinessOpportunityAdd(params) {
        return fetchPost('/partnersBusiness/addPartnersBusiness', params);
    },
    //  服务合作伙伴 -> 商机列表 -> 编辑
    setIndustryPartnersBusinessOpportunityEdit(params) {
        return fetchPost('/partnersBusiness/updatePartnersBusiness', params);
    },
    //  服务合作伙伴 -> 商机列表 -> 删除
    setIndustryPartnersBusinessOpportunityDel(params) {
        return fetchGet('/partnersBusiness/delPartnersBusiness', params);
    },
    //  服务合作伙伴 -> 确认派单/重新派单
    getIndustryPartnersBusinessOpportunityDistributeLeaflets(params) {
        return fetchGet('/partnersBusiness/updatePartnersBusinessStateThree', params);
    },
    //  服务合作伙伴 -> 取消派单
    cancelIndustryPartnersBusinessOpportunityDistributeLeaflets(params) {
        return fetchGet('/partnersBusiness/cancelPartnersBusinessStateThree', params);
    },
    //  服务合作伙伴 -> 商机列表 -> 用户详情
    getIndustryPartnersBusinessOpportunityState(params) {
        return fetchGet('/partnersBusiness/selPartnersBusinessLogList', params);
    },
    selectInformationTwoPageList(params) {
        return fetchPost('/infoGatherTwo/selectInformationTwoPageList', params);
    },
    updateTemplateLogLog(params) {
        return fetchGet('/template/updateTemplateLogLog', params);
    },
    //GET /case/getCasePageList分页整合营销案例列表
    getCasePageList(params) {
        return fetchGet('/case/getCasePageList', params);
    },
    //POST /case/addCase整合营销案例新增
    addCase(params) {
        return fetchPost('/case/addCase', params);
    },
    //POST /case/updateCaseById整合营销案例编辑
    updateCaseById(params) {
        return fetchPost('/case/updateCaseById', params);
    },
    //GET /case/delCaseById整合营销案例删除
    delCaseById(params) {
        return fetchGet('/case/delCaseById', params);
    },
    //GET /case/selCaseById整合营销案例页面信息
    selCaseById(params) {
        return fetchGet('/case/selCaseById', params);
    },
    //Post /case/updateCaseDataById整合营销案例编辑
    updateCaseDataById(params) {
        return fetchPost('/template/updateCaseDataById', params);
    },

    //Post /basicInfo/saveInternalStaff 新增商户用户
    saveInternalStaff(params) {
        return fetchPost('/basicInfo/saveInternalStaff', params);
    },

    //Post /basicInfo/saveInternalStaff 商户用户已购应用
    getPageServiceManagement(params) {
        return fetchPost('/orderProduct/getPageServiceManagement', params);
    },


    //延期接口POST请求：/orderProduct/delay
    delay(params) {
        return fetchPost('/orderProduct/delay', params);
    },

    //日志列表
    logList(params) {
        return fetchPost('/experienceRecord/pageList', params);
    },

    //日志列表
    operationLog(params) {
        return fetchPost('/experienceRecord/getBybpId', params);
    },

    //订单来源
    getOrderSource(params) {
        return fetchGet('/order/getOrderSource', params);
    },

    //订单统计列表
    statistical(params) {
        return fetchPost('/orderStatistics/pageList', params);
    },

    //订单统计列表导出
    exportOrderList(params) {
        return fetchPostBlob('/orderStatistics/exportList', params);
    },

    //订单统计列表导出
    orderRealtime(params) {
        return fetchPost('/orderStatistics/realtime', params);
    },

    //订单概括-各应用成交明细 Post
    orderslist(params) {
        return fetchPost('/orderStatistics/orderlist', params);
    },
    //订单概括-各应用成交明细-详情 Post
    ordersdetails(params) {
        return fetchPost('/orderStatistics/details', params);
    },
    //获取新企业认证列表接口
    getCorpAuthList(params) {
        return fetchGet('/corp/getCorpAuthList', params);
    },
    //获取新企业认证列表接口
    auditCorpAuth(params) {
        return fetchPost('/corp/auditCorpAuth', params);
    },

    // 邀请码列表接口
    invitationGroupList(params) {
        return fetchPost('/invitationGroup/list', params);
    },
    // 邀请码新增接口
    invitationVoucherSave(params) {
        return fetchPost('/invitationVoucher/save', params);
    },
    // 激活码详情列表接口
    invitationVoucherList(params) {
        return fetchPost('/invitationVoucher/list', params);
    },
    // 激活码详情列表接口
    invitationVoucherDetailsList(params) {
        return fetchPost('/invitationVoucherDetails/list', params);
    },
    // 查询活动周期接口
    invitationAppByGroupId(params) {
        return fetchPost('/invitationAppByGroupId', params);
    },
    // 激活码详情导出接口
    downloadInvitationVoucherList(params) {
        return fetchPostBlob('/export/invitationVoucherList', params);
    },
    // 激活码详情导出接口
    downloadInvitationVoucherDetailsList(params) {
        return fetchPostBlob('/export/invitationVoucherDetailsList', params);
    },
    /*-- 发票管理相关接口 --*/
    // 获取列表
    getInvoiceList(params) {
        return fetchPost('/invoice/getInvoiceList', params)
    },
    // 详情
    getInvoiceDetail(params) {
        return fetchPost('/invoice/getInvoiceApprovalInfo', params)
    },
    // 审核列表
    getInvoiceApprovalList(params) {
        return fetchPost('/invoice/getInvoiceApprovalList', params)
    },
    // 审批接口
    sendApproval(params) {
        return fetchPost('/invoice/approval', params)
    },
    // 开票主体
    getStoreList() {
        return fetchPost('/invoice/getStore')
    },
    // 填写寄送信息
    addSenderInfo(params) {
        return fetchPost('/invoice/addSendInfo', params)
    },
    // 发票确认接口
    updateInvoiceStatus(params) {
        return fetchPost('/invoice/updateInvoiceStatus', params)
    },
    // 查看快递公司列表
    getOurierCompanyList(params) {
        return fetchPost('/invoice/getOurierCompanyList', params)
    },
    // 查看物流
    getLogisticsInfo(params) {
        return fetchPost('/invoice/getLogisticsInfo', params)
    },
    // 专票资质查询接口
    getInvoiceQualification(params) {
        return fetchGet('/invoiceQualification', params)
    },
    // 发票删除接口
    getDeleteInvoice(params) {
        return fetchGet('/invoice/deleteInvoices', params)
    },
    // 发票撤销接口
    getRevocationInvoce(params) {
        return fetchGet('/invoice/revocationInvoice', params)
    },
    // 发票通知列表
    getInvoiceNoticeList() {
        return fetchPost('/invoiceNotice/list')
    },
    // 发票通知添加
    getInvoiceNoticeSave(params) {
        return fetchPost('/invoiceNotice/save', params)
    },
    // 发票通知编辑
    getInvoiceNoticeUpdate(params) {
        return fetchPost('/invoiceNotice/update', params)
    },
    // 发票通知删除
    getInvoiceNoticeDel(params) {
        return fetchPost('/invoiceNotice/delete', params)
    },
    /** 个人认证 */
    // 个人认证审核接口
    auditUserAuth(params) {
        return fetchPost('/user/auditUserAuth', params)
    },
    // 个人认证列表查询
    getUserAuthInfoList(params) {
        return fetchGet('/user/getUserAuthInfoList', params)
    },
    // 个人认证导出
    exportUserAuthInfoList(params) {
        return fetchPostBlob('/user/exportUserAuthInfoList', params);
    },
    // 企业认证导出
    exportCorpAuthList(params) {
        return fetchPostBlob('/corp/exportCorpAuthList', params);
    },
    /** 认证设置 */
    // 认证通知列表
    authNoticeList(params) {
        return fetchGet('/authNotice/list', params)
    },
    // 认证通知新增
    authNoticeSave(params) {
        return fetchGet('/authNotice/save', params)
    },
    // 认证通知修改
    authNoticeUpdate(params) {
        return fetchGet('/authNotice/update', params)
    },
    // 认证通知删除
    authNoticeDelete(params) {
        return fetchGet('/authNotice/delete', params)
    },
    //信息咨询
    selectInformationPageList(params) {
        return fetchPost('/information/selectInformationPageList ', params);
    },
}


// WEBPACK FOOTER //
// ./src/api/api.js